import * as d3 from 'd3';

import { LoggerFactory, ILogger } from '../../helpers/helpers';
import { chartSm, chartXs } from '../../constants';
import { OwnAxisFormat } from './ownAxes';

export class IndividualAxes {
    private _container: d3.Selection<any>;
    private _logger: ILogger;

    constructor(container: d3.Selection<any>) {
        this._logger = LoggerFactory.getLogger('WideTech.Charting.individualAxes', false, 0);
        this._container = container.append('g')
            .classed('individual-axes', true)
            .attr('transform', 'translate(20,0)');
    }

    update(series: OwnAxisFormat[], height: number, width: number) {
        this._logger.debug('Updating individual axes.');
        const ratio = this._ratio || 1;
        const dataSelection = this._container
            .selectAll('.individual-axis')
            .data(series);
        //append
        const groups = dataSelection.enter()
            .append('g')
            .classed('individual-axis', true);
        groups.append('text')
            .classed('tickLabel', true)
            .classed('min', true)
            .attr({
                'x': 0,
                'y': (height - 5 * ratio)
            });
        groups.append('text')
            .classed('tickLabel', true)
            .classed('max', true)
            .attr('x', 0)
            .attr('y', 10 * ratio);

        //update
        const translateScale = this._translateScale(width);
        dataSelection.attr(
            'transform', (d, i) => `translate(${translateScale * (i) * ratio},${0})`
        );
        dataSelection.select('.individual-axis')
            .attr('id', d => `axis${d.identifier}`);
        dataSelection.select('.min')
            .style({
                'fill': d => d.color
            })
            .text(d => {
                return d.format ? d.format(d.min) : null;
            });
        dataSelection.select('.max')
            .style({
                'fill': d => d.color
            })
            .text(d => {
                return d.format ? d.format(d.max) : null;
            });

        //delete
        dataSelection.exit().remove();
        this._logger.debug('Individual axes updated.');
    }

    private _translateScale = d3.scale.linear()
        .domain([300, 800])
        .range([27, 35])
        .clamp(true);


    private _ratio: number = 1;
    ratio(): number;
    ratio(value: number): this;
    ratio(value?: number) {
        if (arguments.length) {
            this._ratio = value;
            return this;
        }
        return this._ratio;
    }

    resize(width: number, height: number) {
        this._logger.debug(`Resizing individual axes - width: ${width}, height: ${height}`);
        const ratio = this._ratio || 1;
        const xs = width < chartXs * ratio || height < chartXs * ratio;
        const sm = !xs && (width < chartSm * ratio || height < chartSm * ratio);
        this._container.attr('transform', `translate(${(xs ? 10 : (sm ? 17 : 20)) * ratio},0)`);
        this._container
            .selectAll('.individual-axis')
            .attr('transform', (d, i) => `translate(${this._translateScale(width) * (i) * ratio},${0})`);

        this._container
            .selectAll('.min')
            .attr('y', height - 5 * ratio);
        this._container
            .selectAll('.max')
            .attr('y', 10 * ratio);
        this._logger.debug(`Individual axes resized.`);
    }
}